interface FailedFontLoad {
  fontFamily: string;
  reason: unknown;
}

export const getReasonText = (reason: unknown): string => {
  return reason instanceof Error ? reason.message : String(reason);
};

const getFontLoadErrorMessage = (failedFontLoads: FailedFontLoad[]): string => {
  const failures = failedFontLoads.map(({fontFamily, reason}) => `"${fontFamily}" (${getReasonText(reason)})`);
  return `Fonts failed to load: ${failures.join('; ')}`;
};

/**
 * The rejection a font load hands its caller. It names every family that failed and why, so an item
 * that cannot load without its font is logged with that instead of an empty reason.
 */
export class FontLoadError extends Error {
  constructor(failedFontLoads: FailedFontLoad[]) {
    super(getFontLoadErrorMessage(failedFontLoads));
    this.name = 'FontLoadError';
  }
}

/** Pairs each rejected load with the family at the same index; `Promise.allSettled` keeps input order. */
export const getFailedFontLoads = (fontFamilies: string[], loadResults: PromiseSettledResult<unknown>[]): FailedFontLoad[] => {
  const failedFontLoads: FailedFontLoad[] = [];
  loadResults.forEach((loadResult, index) => {
    if (loadResult.status === 'rejected') {
      failedFontLoads.push({fontFamily: fontFamilies[index], reason: loadResult.reason});
    }
  });
  return failedFontLoads;
};
